<template>
  <div class="container">
    <h1>欢迎使用我们的应用</h1>
    <div class="button-container">
      <button @click="navigateTo('MobileUserManage')" class="btn">账号管理</button>
    </div>
    <button @click="goToHome" class="return-home-button">返回首页</button>

    <!-- 固定在下边的图标按钮行 -->
    <HouseBottom/>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { getCurrentInstance,onMounted } from 'vue';
import HouseBottom from "@/views/house/bottom/houseBottom.vue";

const router = useRouter();
const { proxy } = getCurrentInstance();

const navigateTo = (path) => {
  router.push({ name: path });
};

const goToHome = () => {
      router.push('/');
    };

  const checkLogin = () => {
      let token = localStorage.getItem("token"); // 从缓存中获取token
        token = token || null;
      if (token) {
        // 如果有token，调用后端接口验证
        const url = "/login/checkLoginStatus";
        proxy.$tools
          .request(url, { reqBody: {} })
          .then((response) => {
            const returnCode = response.data.rspHead.reurnCode;
            if (!"000000" === returnCode) {
              router.push("/error");
            }
            const status = response.data.rspBody.status;
            if ("0" === status) {
              router.push("/appLogin");
            } 
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
      } else {
        // 如果没有token，重定向到登录页面
        router.push("/appLogin");
      }
      
      // 这里可以添加查看施工图的逻辑
  
    };

  onMounted(() => {
      checkLogin();
  });

</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: Arial, sans-serif;
}

h1 {
  margin-bottom: 20px;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn:hover {
  background-color: #0056b3;
}

@media (min-width: 768px) {
  .button-container {
    flex-direction: row;
  }

  .btn {
    padding: 15px 30px;
    font-size: 18px;
  }
}

.return-home-button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  margin-top: 20px;
}

.return-home-button:hover {
  background-color: #0056b3;
}



/* 响应式调整 */
@media (max-width: 480px) {
  .icon-button {
    padding: 6px;
  }
  
  .icon {
    width: 22px;
    height: 22px;
  }
  
  .icon-text {
    font-size: 11px;
  }
}

@media (max-width: 375px) {
  .icon-button {
    max-width: 72px;
  }
  
  .icon {
    width: 20px;
    height: 20px;
  }
  
  .icon-text {
    font-size: 10px;
  }
}

/* 响应式设计：对于移动端 */
@media (max-width: 768px) {
  .product-item {
    width: calc(50% - 10px); /* 每行显示两个，预留间隔 */
  }
}

/* 响应式设计：对于平板和桌面端 */
@media (min-width: 768px) {
  .product-item {
    width: calc(50% - 10px);
  }
}

/* 响应式设计：对于桌面端 */
@media (min-width: 992px) {
  .product-item {
    width: calc(33.3333% - 10px);
  }
}
</style>